module.exports = __webpack_public_path__ + "img/parachute-octobre-1.cb67b8b3.jpg";